import {
  DAY_SUMMARY_ALL,
  DAY_SUMMARY_GET,
  DAY_SUMMARY_POST,
  DAY_SUMMARY_PUT,
  DAY_SUMMARY_LOADING,
  DAY_SUMMARY_ERROR,
} from '../../actions/types';

const initialState = {
  daySummary: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case DAY_SUMMARY_LOADING:
      return { isLoading: true, isCompleted: true };
    case DAY_SUMMARY_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case DAY_SUMMARY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DAY_SUMMARY_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DAY_SUMMARY_POST:
      return { isLoading: false, isCompleted: true };
    case DAY_SUMMARY_PUT:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
